import React from "react";

function ChatBubble({ fill = "#FFFFFF", width = 18, height = 18 }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C6.48 2 2 5.58 2 10c0 2.24 1.12 4.27 2.94 5.72L4 22l4.73-2.73C9.78 19.73 10.87 20 12 20c5.52 0 10-3.58 10-8s-4.48-8-10-8zm-1 11H8v-2h3v2zm4 0h-3v-2h3v2zm0-3H8V8h7v2z"
        fill={fill}
      />
    </svg>
  );
}

export default ChatBubble;
